/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Form, Input, Button, Select, InputNumber } from "antd";
import { updateJackpotEntry, getJackpotEntry } from "../../features/jackpot/jackpotSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
import { useParams } from "react-router-dom";

const { Option } = Select;

const ViewJackpotExtries = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, updating, message, isUpdateSuccess, jackpotEntry } = useSelector(
    (state) => state.jackpot
  );
  const [form] = Form.useForm();

  const onFinish = (values) => {
    const data = { ...values };
    data.status = parseInt(values.status);
    dispatch(updateJackpotEntry({ id, data }));
  };

  useEffect(() => {
    loadJackpotEntry();
  }, []);

  useEffect(() => {
    if (jackpotEntry) {
      form.setFieldsValue({
        player_name: jackpotEntry?.user?.first_name + " " + jackpotEntry?.user?.last_name,
        club_name: jackpotEntry?.club_name,
        hole_number: jackpotEntry?.hole_number,
        country_code: jackpotEntry?.country_code,
        phone_number: jackpotEntry?.phone_number,
        social_media_url: jackpotEntry?.social_media_url,
        points: jackpotEntry?.points,
        status: jackpotEntry?.status?.toString(),
      });
    }
  }, [jackpotEntry]);

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "Video submission is updated successfully",
      });
      navigate("/admin/hole-in-one-video-submissions");
    }
  }, [isError, message, isUpdateSuccess, messageApi, navigate]);

  const loadJackpotEntry = () => {
    dispatch(getJackpotEntry(id));
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Video Submission</h3>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          label="Player Name"
          name="player_name"
          rules={[{ required: true, message: "Please input the player name!" }]}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          label="Club Name"
          name="club_name"
          rules={[{ required: true, message: "Please input the description!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Hole Number"
          name="hole_number"
          rules={[{ required: true, message: "Please input the hole number!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Country Code"
          name="country_code"
          rules={[{ required: true, message: "Please input the country code!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="phone_number"
          rules={[{ required: true, message: "Please input the phone number!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Social Media URL"
          name="social_media_url"
          rules={[{ required: false, message: "Please input the social media url!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Points"
          name="points"
          rules={[{ required: true, message: "Please input the points!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Pending</Option>
            <Option value="2">Approved</Option>
            <Option value="3">Rejected</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={updating}>
            {updating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ViewJackpotExtries;
